import { Avatar, Button, GenericWrapperContext, SideMenuItem, TextField, Typography, UserModel } from "@cakemail-org/ui-components-v2"
import { useContext, useEffect } from "react"
import { Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TOnboardingUserSetup } from "./types"
import { OnboardingContext } from "../../context"
import { EOnboardingStep } from "../../types"
export function OnboardingUserSetup({ }: TOnboardingUserSetup) {
    const genericWrapper = useContext(GenericWrapperContext)
    const onboardingContext = useContext(OnboardingContext)
    const { t } = useTranslation()

    function handleFieldChange(e: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = e.target
        onboardingContext.userForm.set(name as keyof UserModel, value)
        onboardingContext.setUserForm(new UserModel(onboardingContext.userForm))
    }

    function handleNext() {
        onboardingContext.handleNext()
    }



    let firstName = onboardingContext.userForm.first_name?.replace("-", "")
    let lastName = onboardingContext.userForm.last_name?.replace("-", "")

    const continueDisabled = !firstName || !lastName

    const enrichedPerson = onboardingContext.enrichedPerson

    const missingName = !enrichedPerson?.first_name || !enrichedPerson?.last_name

    return <Stack direction="column" className="onboardingUserSetup" gap={enrichedPerson?.email ? 4 : 8} flex={1}>

        {(enrichedPerson?.email && !missingName) && <>
            <SideMenuItem
                item={{
                    prefix: <Avatar email={enrichedPerson.email} firstName={enrichedPerson.first_name} lastName={enrichedPerson.last_name} sizes={40} />,
                    text: enrichedPerson.first_name + " " + enrichedPerson.last_name,
                    support: enrichedPerson?.title,
                    name: "onboarding-link-me"
                }}
                variant="soloItem"
                menuItemClick={() => {
                    onboardingContext.setUserForm(new UserModel({
                        email: enrichedPerson.email,
                        first_name: enrichedPerson.first_name,
                        last_name: enrichedPerson.last_name,
                        title: enrichedPerson.title,
                    }))
                    onboardingContext.handleNext()
                }}
                selected={false}
            />
            <SideMenuItem
                item={{
                    text: t("onboarding-link-not-me"),
                    name: "onboarding-link-not-me"
                }}
                variant="soloItem"
                menuItemClick={() => {
                    if (enrichedPerson) {
                        onboardingContext.setEnrichedPerson({
                            ...enrichedPerson,
                            email: "",
                        })
                    }

                    onboardingContext.userForm.set("first_name", genericWrapper.user.first_name)
                    onboardingContext.userForm.set("last_name", genericWrapper.user.last_name)
                    onboardingContext.setUserForm(new UserModel(onboardingContext.userForm))

                    onboardingContext.setStep(EOnboardingStep.user)
                }}
                selected={false}
            />
        </>}

        {(!enrichedPerson?.email || missingName) && <>
            <TextField
                label={t("general-first-name")}
                name="first_name"
                value={firstName}
                onChange={handleFieldChange}
                placeholder={t("general-first-name-placeholder")}
            />
            <TextField
                label={t("general-last-name")}
                name="last_name"
                value={lastName}
                onChange={handleFieldChange}
                placeholder={t("general-last-name-placeholder")}
            />

            <Stack direction="row" className="onboardingContent" justifyContent="flex-end">
                <Button variant="contained" color="secondary" onClick={handleNext} disabled={continueDisabled}>
                    {t("general-continue")}
                </Button>
            </Stack>
        </>}
    </Stack>
}

export default OnboardingUserSetup